// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1__bb3197cf35753dc6fa92{/*!*/}.SimplePaperPodcast-cls2___eafa48f03e34bc93596{font-size:12px;color:#9ca3af;margin-top:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1__bb3197cf35753dc6fa92",
	"cls2": "SimplePaperPodcast-cls2___eafa48f03e34bc93596 SimplePaperPodcast-cls1__bb3197cf35753dc6fa92"
};
export default ___CSS_LOADER_EXPORT___;
